<div class="d-flex flex-column no-scroll-bar overflow-hidden h-100 w-100">
    @if (viewportService.isLargeViewPort()) {
        <app-nav-bar/>
        <app-offline/>
        <div class="d-flex overflow-hidden h-100 position-relative">
            <app-internal-notifications/>
            @if (mainViewStore.childComponentVisible()) {
                <div class="start-0 z-mid-2 width-400px background-white">
                    <router-outlet/>
                </div>
            }
            <app-map-container class="position-absolute w-100 h-100"/>
        </div>
    } @else {
        <div class="d-flex flex-column overflow-hidden h-100">
            <app-offline/>
            <app-internal-notifications/>
            <div class="position-relative h-100 w-100">
                @if (!mainViewStore.childComponentVisible()) {
                    <div class="position-absolute top-0 start-50 translate-middle-x margin-top-100px z-mid-1 w-75 max-width-700px">
                        <app-search-bar/>
                    </div>
                }
                <app-map-container class="position-absolute w-100 h-100"/>
                @if (mainViewStore.childComponentVisible()) {
                    <div class="position-absolute w-100 h-100">
                        <router-outlet/>
                    </div>
                }
            </div>
        </div>
        <div class="z-max w-100 border-top border-dark-subtle background-white bottom-0 mobile-menu flex-none">
            <div class="row d-flex justify-content-between h-100 pt-2">
                <app-nav-button
                        (click)="!disabled && toggleInformationCenter()"
                        [active]="informationCenterVisible()"
                        [alwaysShowText]="true"
                        [buttonClass]="'btn-navigation w-100'"
                        [buttonText]="'Overview'"
                        [disabled]="disabled"
                        [icon]="'fa-solid fa-list fa-xl'"
                        class="col-4 p-0 pointer"/>
                <app-nav-button
                        (click)="!disabled && toggleMap()"
                        [active]="mapVisible()"
                        [alwaysShowText]="true"
                        [buttonClass]="'btn-navigation w-100'"
                        [buttonText]="'Map'"
                        [disabled]="disabled"
                        [icon]="'fa-solid fa-map fa-xl'"
                        class="col-4 p-0 pointer"/>
                <app-nav-button
                        (click)="!disabled && toggleNotifications()"
                        [active]="notificationsVisible()"
                        [alwaysShowText]="true"
                        [buttonClass]="'btn-navigation w-100'"
                        [buttonText]="'Notifications'"
                        [disabled]="disabled"
                        [icon]="'fa-solid fa-bell fa-xl'"
                        class="col-4 p-0 pointer"/>
            </div>
        </div>
    }
</div>
